<template>
  <span v-on:click="clicktolink">
    <slot></slot>
  </span>
</template>

<script>
    import i18n from '@/i18n';
    import Helper from '@/helper/Helper';
//    const {ipcRenderer} = require('electron');

    export default {
        name: 'BtnExit',
        props: {
        },
        methods: {
            clicktolink(e){
                console.log("clicktolink");
                const modul = this;
                e.preventDefault();
              modul.$router.push({name: "login"})
//                if (confirm("Biztos kilép?")) {
//                    setTimeout(function () {
//                    }, 500);
//                }
            },
        }
    };
</script>

<style>
</style>

